import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AngularModule } from 'shared/modules/angular/angular.module';
import { MaterialModule } from 'shared/modules/material/material.module';
import { SearchBarComponent } from './search-bar.component';

@NgModule({
  declarations: [
    SearchBarComponent,
  ],
  exports: [
    SearchBarComponent,
  ],
  imports: [
    TranslateModule,
    CommonModule,
    AngularModule,
    MaterialModule,
  ],
})
export class SearchBarModule {
}
